if (!customElements.get('collapsible-content')) {
  customElements.define(
    'collapsible-content',
    class CollapsibleContent extends HTMLElement {
      constructor() {
        super();

        this.summaries = this.querySelectorAll('.collapsible-content__summary');

        this.summaries.forEach((summary) => {
          summary.addEventListener('click', () => {
            this.closeOtherAccordions(summary);
          });
        });
      }

      closeOtherAccordions(e) {
        document
          .querySelectorAll('.collapsible-content__summary')
          .forEach((summary) => {
            if (
              summary !== e &&
              summary.closest('details').hasAttribute('open')
            ) {
              summary.closest('details').removeAttribute('open');
            }
          });
      }
    }
  );
}
